module.exports = __webpack_public_path__ + "img/video_bg.9ff745cc.png";